@if (!showPopover) {
    <div
        class="avatar"
        [class.avatar--small]="small"
        [class.avatar--medium]="medium"
        [class.avatar--large]="large"
        [class.avatar--xl]="xlarge"
        [title]="title || ''"
        [style.backgroundColor]="!thumbnail && avatarBGColor"
        kendoTooltip
        filter="#avatar-state"
        [offset]="8">
        <ng-container [ngTemplateOutlet]="userAvatar"></ng-container>
    </div>
} @else {
    <div
        #avatar="kendoPopoverAnchor"
        class="avatar"
        [class.avatar--small]="small"
        [class.avatar--medium]="medium"
        [class.avatar--large]="large"
        [class.avatar--xl]="xlarge"
        [title]="title || ''"
        [style.backgroundColor]="!thumbnail && avatarBGColor"
        kendoTooltip
        filter="#avatar-state"
        (mouseleave)="onHideData()"
        kendoPopoverAnchor
        [popover]="userPopover"
        [showOn]="popoverOnClick ? 'click' : 'hover'">
        <ng-container [ngTemplateOutlet]="userAvatar"></ng-container>
    </div>
}

<ng-template #userAvatar>
    @if (!thumbnail && initials) {
        <span class="avatar__label" [textContent]="initials" title=""></span>
    }
    @if (!thumbnail && !initials && chatroom) {
        <span class="avatar__icon icon icon-group"></span>
    }
    @if (!thumbnail && !initials && anonymous) {
        <span class="avatar__icon icon icon-heisenberg"></span>
    }
    @if (thumbnail) {
        <img class="avatar__thumbnail" [src]="thumbnail" loading="lazy" (error)="onImageError($event)" />
    }
    @if (
        (state === USER_STATES.PENDING_ACTIVATION || state === USER_STATES.LOCKED || state === USER_STATES.EXPIRED_CREDENTIALS) || (state === USER_STATES.REGISTERED && !access)
    ) {
        <span
            id="avatar-state"
            class="avatar__state"
            [class.avatar__state--warning]="state === USER_STATES.REGISTERED && !access"
            [title]="getUserStatusText()"></span>
    }
</ng-template>

<kendo-popover
    #userPopover
    [width]="450"
    [position]="popoverPosition || 'bottom'"
    [callout]="false"
    [offset]="10"
    [animation]="{type: 'fade', duration: 150, direction: 'down'}"
    (show)="onShowData($event, userPopover)"
    (hide)="onHideData()"
    (hidden)="!shortVersion ? moreDetails = false : moreDetails = true">
    <ng-template kendoPopoverBodyTemplate>
        <section class="user-popover" [tabIndex]="0">
            <div class="avatar avatar--large" [style.backgroundColor]="!thumbnail && avatarBGColor">
                @if (!thumbnail && initials) {
                    <span class="avatar__label" [textContent]="initials"></span>
                }
                @if (!thumbnail && !initials && anonymous) {
                    <span class="avatar__icon icon icon-heisenberg"></span>
                }
                @if (thumbnail) {
                    <img class="avatar__thumbnail" [src]="thumbnail" loading="lazy" (error)="onImageError($event)" />
                }
            </div>
            <div class="user-popover__content">
                <section class="user-popover__header">
                    <h4 class="user-popover__employee-name" [textContent]="name + ' ' + surname"></h4>
                    @if (!isSyncing) {
                        <p
                            class="user-popover__subtitle"
                            [textContent]="additionalData?.companyPosition ? additionalData?.companyPosition : additionalData?.username"></p>
                        <p class="user-popover__location">
                            <span [textContent]="additionalData?.subsidiaryCompany?.name"></span>
                            @if (additionalData?.subsidiaryCompany?.name && additionalData?.headquarter?.name) {
                                <span [textContent]="', '"></span>
                            }
                            <span [textContent]="additionalData?.headquarter?.name"></span>
                        </p>
                    }
                </section>

                @if (moreDetails) {
                    <p class="user-popover__location margin-top-2">
                        <span [textContent]="additionalData?.department?.name"></span>
                        @if (additionalData?.department?.name && additionalData?.team?.name) {
                            <span [textContent]="' · '"></span>
                        }
                        <span [textContent]="additionalData?.team?.name"></span>
                    </p>
                    @if (additionalData?.showIdentificationGroup) {
                        <hr class="divider margin-block-20" />
                        <section class="user-popover__section">
                            <h5 class="user-popover__section-title" [translate]="'users.popover.identificationGroupTitle'"></h5>
                            @if (additionalData?.nationalIdNumber) {
                                <div class="user-id-data" (mouseenter)="showCopyIcon('nationalId')" (mouseleave)="hideCopyIcon('nationalId')">
                                    <div class="user-id-data__tag">
                                        <span [translate]="'users.popover.nationalId'"></span>
                                        <span class="truncate" [textContent]="additionalData?.nationalIdNumber"></span>
                                    </div>
                                    @if (isCopyIconVisible['nationalId']) {
                                        <button
                                            type="button"
                                            class="icon icon-16 icon-copy"
                                            (click)="copyToClipboard(additionalData?.nationalIdNumber)"></button>
                                    }
                                </div>
                            }
                            @if (additionalData?.companyInternalId) {
                                <div class="user-id-data" (mouseenter)="showCopyIcon('internalId')" (mouseleave)="hideCopyIcon('internalId')">
                                    <div class="user-id-data__tag">
                                        <span [translate]="'users.internalId'"></span>
                                        <span class="truncate" [textContent]="additionalData?.companyInternalId"></span>
                                    </div>
                                    @if (isCopyIconVisible['internalId']) {
                                        <button class="icon icon-16 icon-copy" (click)="copyToClipboard(additionalData?.companyInternalId)"></button>
                                    }
                                </div>
                            }
                            @if (additionalData?.companyPosition) {
                                <div class="user-id-data" (mouseenter)="showCopyIcon('username')" (mouseleave)="hideCopyIcon('username')">
                                    <div class="user-id-data__tag">
                                        <span [translate]="'users.popover.dialengaId'"></span>
                                        <span class="truncate" [textContent]="additionalData?.username"></span>
                                    </div>
                                    @if (isCopyIconVisible['username']) {
                                        <button class="icon icon-16 icon-copy" (click)="copyToClipboard(additionalData?.username)"></button>
                                    }
                                </div>
                            }
                        </section>
                    }
                    @if (additionalData?.showResponsibleGroup && !shortVersion) {
                        <hr class="divider margin-block-20" />
                        <section class="user-popover__section">
                            <h5 class="user-popover__section-title" [translate]="'model.teams.teamLeader'"></h5>
                            <div class="flex align-items-center">
                                <div
                                    class="avatar avatar--small"
                                    [style.backgroundColor]="!additionalData.team.responsible.thumbnail && additionalData.team.responsible.avatarBGColor">
                                    @if (!additionalData.team.responsible.thumbnail && additionalData.team.responsible.initials) {
                                        <span class="avatar__label" [textContent]="additionalData.team.responsible.initials"></span>
                                    }
                                    @if (additionalData.team.responsible.thumbnail) {
                                        <img
                                            class="avatar__thumbnail"
                                            [src]="additionalData.team.responsible.thumbnail"
                                            loading="lazy"
                                            (error)="onImageError($event)" />
                                    }
                                </div>
                                <p class="font-size-13 black-85 margin-left-8" [textContent]="additionalData.team.responsible.fullName"></p>
                            </div>
                        </section>
                    }
                }

                @if (!moreDetails && (additionalData?.showIdentificationGroup || additionalData?.showResponsibleGroup)) {
                    <button type="button" class="user-popover__link-button margin-top-16" (click)="$event.stopPropagation(); moreDetails = true">
                        <span [translate]="'users.popover.moreDetails'"></span>
                        <span class="icon icon-arrow-down margin-left-4"></span>
                    </button>
                }
            </div>
            @if (!shortVersion) {
                <button
                    type="button"
                    class="user-popover__edit-button"
                    kendoTooltip
                    [offset]="4"
                    [title]="'users.edituser' | translate"
                    (click)="goToUserProfile()"
                    [attr.aria-label]="'users.edituser' | translate">
                    <span class="icon icon-edit" aria-hidden="true"></span>
                </button>
            }
        </section>
    </ng-template>
</kendo-popover>
